"use client";

// Imports
import { createContext } from "react";
import { usePreloadedQuery } from "convex/react";

// ✅ Convex Data Context Type
export const ConvexDataContext = createContext();

function ConvexDataProviderWithPreload({
  children,
  preloadedMember,
  kindeUser,
  isAdmin,
}) {
  const member = usePreloadedQuery(preloadedMember);
  return (
    <ConvexDataContext.Provider value={{ member, kindeUser, isAdmin }}>
      {children}
    </ConvexDataContext.Provider>
  );
}

// ✅ Convex Data Provider Component
export const ConvexDataProvider = ({
  children,
  preloadedMember,
  kindeUser,
  isAdmin,
}) => {
  if (!preloadedMember) {
    return (
      <ConvexDataContext.Provider value={{ member: null, kindeUser, isAdmin }}>
        {children}
      </ConvexDataContext.Provider>
    );
  }
  return (
    <ConvexDataProviderWithPreload
      preloadedMember={preloadedMember}
      kindeUser={kindeUser}
      isAdmin={isAdmin}
    >
      {children}
    </ConvexDataProviderWithPreload>
  );
};
